import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "projects/tilmanagement/src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class LookupService {
  private baseUrl = environment.apiUrl + "/lookups";
  constructor(private http: HttpClient) {}

  getLookups(lookupTypeId: number) {
    return this.http.get<any[]>(`${this.baseUrl}/${lookupTypeId}`);
  }

  addLookup(lookupName: string) {
    return this.http.post<any>(`${this.baseUrl}`, JSON.stringify(lookupName), {
      headers: { "Content-Type": "application/json" },
    });
  }
}
